export default __webpack_public_path__ + "static/media/pension_dark.6d015717.png";